export const sortByPropertyNameAsc = (key: string) => {
  return (a: any, b: any) => {
    return (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0);
  };
};

export const hex2rgba = (hex: string, alpha: number = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};